<qai-inner-wrap>
  <div class="assignments-tab" *ngIf="isTranslationLoaded">
    <div class="header-row">
      <qai-tabs #tabsComponent (tabSelected)="onTabChange($event)" class="assignments-tabs"
        label="{{ 'reportingV2.ASSIGNMENT_LABEL' | transloco }}"
        *ngIf="isTeamAvailable && !isNetworkCallInprogress; else noTeams">
        <ng-template qaiTab="practice" label="{{ 'reportingV2.PRACTICE_LABEL' | transloco }}">
          <div class="tab-content">
            <app-practice-tab [selectedAccount]="selectedAccount" [selectedTeams]="selectedTeams"
              [tabActive]="activeTab === PRACTICE_TAB"></app-practice-tab>
          </div>
        </ng-template>

        <ng-template qaiTab="certification" label="{{ 'reportingV2.CERTIFICATION_LABEL' | transloco }}">
          <div class="tab-content">
            <app-certification-tab [selectedAccount]="selectedAccount" [selectedTeams]="selectedTeams"
              [tabActive]="activeTab === CERTIFICATION_TAB"></app-certification-tab>
          </div>
        </ng-template>
      </qai-tabs>
      <ng-template #noTeams>
        <!-- Empty State -->
        <div *ngIf="
        !isLoading &&
        !isNetworkCallInprogress" class="empty-container">
          <p>{{ "reportingV2.NO_TEAMS_DATA" | transloco }}</p>
        </div>
      </ng-template>
    </div>
    <div class="loading-container" *ngIf="isNetworkCallInprogress">
      <qai-loading size="medium"></qai-loading>
    </div>
  </div>
</qai-inner-wrap>
